import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const trackPageLoaded = (options = {}) => {
  window.analytics?.page(options);
};

export const trackDataActionClick = (event) => {
  if (event.target.getAttribute('data-action')) {
    window.analytics?.track('NavigationClicked', {
      action: 'NavigationClicked',
      label: event.target.getAttribute('data-action'),
      category: event.target.getAttribute('data-category'),
    });
  }
};

export const trackButtonClick = ({ label, location }) =>
  window.analytics?.track('Button Clicked', { label, location });

export const trackListFiltered = ({ label, location, selection }) =>
  window.analytics?.track('List Filtered', { label, location, selection });

export const getLastReferrer = () => {
  const hostname = document.location.hostname;
  const referrer = document.referrer;

  if (
    referrer.indexOf(publicRuntimeConfig.trustpilotApiHost) === -1 &&
    referrer.indexOf(hostname) === -1
  ) {
    return !referrer ? 'direct' : referrer;
  }

  return undefined;
};
